import DefaultMapper, { toPagingAndSorting, mapIdInList, addCustomMethods } from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { stringify } from 'query-string';
import { API_BASE_PATH_DEMOWALLET_ADMIN } from '../../constants';

class LoyaltyProgramMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/loyalty/programs';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.method = 'POST';
		switch (params.method) {
			// Cases: LockLoyaltyProgram/ActivateLoyaltyProgram and DeleteLoyaltyProgram
			case 'activate':
			case 'lock':
			case 'delete':
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
				break;
			default:
				// Case: CreateLoyaltyProgram
				options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}`;
				options.body = JSON.stringify({
					name: params.data.name,
					loyaltyPercentage: params.data.loyaltyPercentage,
					ownerId: params.data.ownerId,
					ownerType: 'ShopConfiguration',
					amount: params.data.amount,
					walletId: params.data.walletId,
				});
				break;
		}
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params),
		};
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}?${stringify(query)}`;
	}

	finishGetList({ result }) {
		return mapIdInList(super.finishGetList({ result }), 'id');
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
	}
}

export default LoyaltyProgramMapper;
